import React from "react";
import styles from "./Footer.module.css";
import Logo from "../../assets/images/Louisville-logo2.png";
import safeLogo from "../../assets/images/safe-louisville-logo.jpg";

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerLogos}>
        <img src={Logo} alt={Logo} className={styles.footerLogo} />
        <img src={safeLogo} alt={safeLogo} className={styles.footerLogo} />
      </div>
      <p>Louisville-Jefferson County Metro Government.</p>
    </footer>
  );
};

export default Footer;
